import { EgretLoadable } from 'egret';
import { authRoles } from '../../auth/authRoles';

const Merchant = EgretLoadable({
  loader: () => import('./Merchant')
});

const dashboardRoutes = [
  {
    path: '/dashboard/merchant',
    component: Merchant,
    auth: authRoles.merchant
  }
];

export default dashboardRoutes;
